import { WindowOpener } from "../../../components/system/utilities";
import { ExecuteRequest, ExternalScriptExecuteResult } from "../../../domain/localhost/items";
import { Dictionary } from "../../../domain/system";
import { IWebApplicationMessageCommunicatable } from "../../../domain/localhost";
import { HisDataPickerCommunicator, IntroductionSelectorCommunicator } from "./communicator";
import Enumerable from "linq";

export class ExternalWebApplicationManager {
  /**
   * 結果格納前にウィンドウが閉じられたことを検知するために開いたウィンドウのインスタンスを保持している
   */
  private static _openedWindows = new Dictionary<string, WindowProxy>();

  public isProcessible(additionalInfo: any): boolean {
    if (!(additionalInfo instanceof ExecuteRequest)) { return false; }
    const communicator = this.createCommunicator(additionalInfo, null, null, null);
    return !!communicator;
  }

  public createCommunicator(request: ExecuteRequest, registerResult: (result: ExternalScriptExecuteResult) =>  Promise<void>, getConfiguration: (key: string) => Promise<any>, key: string): IWebApplicationMessageCommunicatable {
    const communicators = [
      new HisDataPickerCommunicator(request, registerResult, getConfiguration),
      new IntroductionSelectorCommunicator(request, registerResult, getConfiguration, key),
    ];
    return Enumerable.from(communicators).firstOrDefault(c => c.isProcessible());
  }

  public launch(requestKey: string): void {
    const openedWindow = WindowOpener.openWindow("/WebApplicationAdapter?requestKey=" + requestKey);
    if (openedWindow) {
      ExternalWebApplicationManager._openedWindows.set(requestKey, openedWindow);
    }
  }

  public isWebApplicationClosed(requestKey: string): boolean {
    if (!ExternalWebApplicationManager._openedWindows.containsKey(requestKey)) { return false; }
    const openedWindow = ExternalWebApplicationManager._openedWindows.get(requestKey);
    return openedWindow && openedWindow.closed;
  }
}
